module.exports = __webpack_public_path__ + "icon_info.936c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_info.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_info.svg
// module chunks = main